"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function ImageGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const images = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/professional_finance_office.png",
    alt: "Modern finance office workspace",
    caption: "Professional Workspace"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/financial_data_analysis.png",
    alt: "Financial data analysis on screens",
    caption: "Data-Driven Insights"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/collaborative_meeting_room.png",
    alt: "Collaborative finance team meeting",
    caption: "Expert Collaboration"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/abstract_financial_texture.png",
    alt: "Abstract financial texture pattern",
    caption: "Strategic Planning"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/digital_finance_technology.png",
    alt: "Digital finance technology interface",
    caption: "Innovative Solutions"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/modern_accounting_workspace.png",
    alt: "Modern accounting workspace setup",
    caption: "Precision & Accuracy"
  }];
  return <section id="image-grid" ref={ref} className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {images.map((image, i) => <div key={i} data-index={i} className={`group relative overflow-hidden rounded-[var(--radius-md)] bg-surface border border-border shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:shadow-medium ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: isVisible ? `${i * 50}ms` : "0ms"
        }}>
              <AspectRatio ratio={4 / 3}>
                <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-150 ease-out group-hover:scale-105" />
                <div className="absolute inset-0 bg-primary/80 opacity-0 group-hover:opacity-100 transition-opacity duration-150 ease-out flex items-center justify-center">
                  <p className="text-foreground-primary text-lg md:text-xl font-semibold text-center px-4">
                    {image.caption}
                  </p>
                </div>
              </AspectRatio>
            </div>)}
        </div>
      </div>
    </section>;
}